import PageLayout from "../../components/feature/PageLayout";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";

export default function Company() {
  return (
    <PageLayout>
      <HeroSection />
      <AboutSection />
    </PageLayout>
  );
}
